import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, {
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VToolbar,
  VCarousel,
  VCard,
  VTextField,
  VAlert,
  VCheckbox,
  VForm,
  VDivider,
  VMenu,
  VProgressCircular,
  VAvatar,
  VDialog,
  VDataTable,
  VSubheader,
  VTooltip,
  VTabs,
  VSelect,
  VExpansionPanel,
  VSnackbar
} from 'vuetify/lib'
// import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VToolbar,
    VCarousel,
    VCard,
    VTextField,
    VAlert,
    VCheckbox,
    VForm,
    VDivider,
    VMenu,
    VProgressCircular,
    VAvatar,
    VDialog,
    VDataTable,
    VSubheader,
    VTooltip,
    VTabs,
    VSelect,
    VExpansionPanel,
    VSnackbar
  },
  theme: {
    themes: {
      light: {
        primary: colors.teal.darken1, // #E53935
        secondary: colors.teal.lighten4, // #FFCDD2
        accent: colors.indigo.base // #3F51B5
      }
    }
  }
})
